.handle {
  flex: 0 0 6px;
  cursor: col-resize;
  background-color: var(--tuna-palette-divider);
  transition: background-color 0.12s ease;
  /* Generous hit-target on hover even though the visible bar is thin. */
  position: relative;
  z-index: 1;
  /* A touch or pen drag resizes rather than scrolls (GH #2976) */
  touch-action: none;
}

.handle:hover,
.handle:focus-visible {
  background-color: var(--tuna-palette-primary-main);
}

.handle:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}
